import { TutorialSectionType } from './types';
import { MobileDetector, CustomEvents } from '@powerplay/common';
export class TutorialManager {
    actualSection = 0;
    tutorialSections = [];
    inputsBlocked = false;
    typeWriting = false;
    timeoutInputsBlocked;
    callbackResumeGame;
    setTypeWriting(state) {
        this.typeWriting = state;
    }
    getTypeWriting() {
        return this.typeWriting;
    }
    setTutorialSections(tutorialSections) {
        this.tutorialSections = tutorialSections;
        return this;
    }
    getActualSectionId() {
        return this.actualSection;
    }
    setActualSectionId(sectionId) {
        if (sectionId < 0 || sectionId >= this.tutorialSections.length) {
            throw Error('Index out of bounds');
        }
        const actualRunningSection = this.getSectionById(this.actualSection);
        if (actualRunningSection?.sectionLogicFinish) {
            actualRunningSection?.sectionLogicFinish();
        }
        this.actualSection = sectionId;
        const actualRunningSection2 = this.getSectionById(this.actualSection);
        if (actualRunningSection2?.sectionLogicIntro) {
            actualRunningSection2?.sectionLogicIntro();
        }
        return this;
    }
    nextSection() {
        const actualRunningSection = this.getSectionById(this.actualSection);
        if (actualRunningSection?.sectionLogicFinish) {
            actualRunningSection?.sectionLogicFinish();
        }
        this.actualSection++;
        if (this.actualSection >= this.tutorialSections.length)
            return;
        const actualRunningSection2 = this.getSectionById(this.actualSection);
        if (actualRunningSection2?.sectionLogicIntro) {
            actualRunningSection2?.sectionLogicIntro();
        }
    }
    prevSection() {
        if (this.actualSection <= 0)
            return;
        this.actualSection--;
    }
    actionPressed() {
        if (this.typeWriting) {
            this.typeWriting = false;
            window.dispatchEvent(new CustomEvent(CustomEvents.typeWrite));
            if (!this.inputsBlocked)
                this.blockInputsManually();
            return;
        }
        if (TutorialSectionType.storyButton === this.getActualSectionType()) {
            if (MobileDetector.isMobile()) {
                if (this.inputsBlocked)
                    return;
            }
            else {
                this.callbackResumeGame?.();
                this.nextSection();
            }
        }
        if (TutorialSectionType.gameEvent === this.getActualSectionType()) {
            if (this.inputsBlocked)
                return;
            window.dispatchEvent(new CustomEvent(CustomEvents.tutorialGameEvent));
        }
        if (TutorialSectionType.gameButton === this.getActualSectionType()) {
            if (this.inputsBlocked)
                return;
        }
        if (TutorialSectionType.gameInput === this.getActualSectionType() ||
            TutorialSectionType.storyInput === this.getActualSectionType()) {
            if (this.inputsBlocked)
                return;
            this.callbackResumeGame?.();
            this.nextSection();
        }
        this.blockInputsManually();
    }
    blockInputsManually(timeoutTime = 500) {
        this.inputsBlocked = true;
        if (this.timeoutInputsBlocked) {
            window.clearTimeout(this.timeoutInputsBlocked);
        }
        if (timeoutTime === 0)
            return;
        this.timeoutInputsBlocked = window.setTimeout(() => {
            this.inputsBlocked = false;
            this.timeoutInputsBlocked = undefined;
        }, timeoutTime);
    }
    getSections() {
        return this.tutorialSections;
    }
    getActualSectionName() {
        const section = this.getSectionById(this.actualSection);
        return section?.name;
    }
    getActualSectionType() {
        const section = this.getSectionById(this.actualSection);
        return section?.type;
    }
    getSectionByName(name) {
        return this.tutorialSections.filter(section => section.name === name)[0];
    }
    getSectionById(id) {
        return this.tutorialSections.filter(section => section.id === id)[0];
    }
    listenToNextEvent() {
        window.addEventListener('nextSection', this.nextSection);
    }
    listenToPreviousEvent() {
        window.addEventListener('prevSection', this.prevSection);
    }
    listen(callbackResumeGame) {
        this.callbackResumeGame = callbackResumeGame;
        this.listenToNextEvent();
        this.listenToPreviousEvent();
        console.log('Tutorial listen..');
    }
}
//# sourceMappingURL=TutorialManager.js.map